import React, { useState, useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';


const Input = forwardRef((props, ref) => {
    
    const [value, setValue] = useState(props.value || '');
    const [isValid, setIsValid] = useState(false);
    const [showMessage, setShowMessage] = useState(false);

    let message = props.message.error || '';
    useEffect(() => {
        if(props.validateForm){
            props.validateForm();
        } 
    },[isValid])

    const _onChange = (event) => {
        const validate = props.onChange ? props.onChange(event.target.value) : isValid;
        setValue(event.target.value);
        setShowMessage(true);
        setIsValid(validate)
        props.callbackValidate(validate)
        props.validateForm();
    }

    const _onBlur = () => {
        if (!props.validate) return false;

        const valid = props.validate(value);

        setShowMessage(true);
        setIsValid(valid);
        props.callbackValidate(valid);
        props.validateForm();
    }

    useEffect(() => {
        if(value && value.trim()){
            _onBlur();
        }
    }, [])

    useEffect(() => {
        if(value !== props.value){
            setValue(props.value);
        }
    }, [props.value])


    return (
        <div className={"input-wrapper short " + (!isValid && showMessage ? 'is-error' : '')}>
            <label>
                <div className={"label " + (props.required ? "required" : '')}>
                    {props.label}
                </div>
                <input
                    ref={ref}
                    type={props.type}
                    value={value}
                    name={props.name}
                    onChange={_onChange}
                    className={props.className}
                    onBlur={_onBlur}
                />
                <p className='error'>
                    {message}
                </p>
            </label>
        </div>
    )
});

Input.propTypes = {
    type: PropTypes.string,
    value: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    validate: PropTypes.func,
    callbackValidate: PropTypes.func,
    className: PropTypes.string,
    onChange: PropTypes.func,
    message: PropTypes.object,
    validateForm: PropTypes.func,
    required: PropTypes.bool
}
Input.displayName = 'Input'
export default Input;
